module.exports = __webpack_public_path__ + "static/media/video_off.2cfd8c7d.svg";